import { EnvironmentHelper } from '@biteinc/enums';

import { updateSimphonyPasswordsSchema } from './update_simphony_passwords_schema';

app.InternalToolsView = app.BaseToolsView.extend({
  _refreshDayPartsClicked(event) {
    const $button = $(event.target);
    const reqId = $button.initLoadingButton(
      $button.html(),
      'Making Request',
      'Refresh in Progress',
    );
    const url = '/api/v2/internal-tools/refresh-day-parts';
    app.makeRequest(
      'POST',
      url,
      null,
      () => {
        $button.loadingDidFinishSuccessfully(reqId);
      },
      () => {
        $button.loadingDidFinishWithError(reqId);
      },
    );
  },

  _refreshMenuCachesClicked(event) {
    const confirmed = app.promptUserToTypeInConfirmation(
      'This will refresh the menu cache for all locations across Bite. While processing, menu fetches may take longer than expected and cause timeouts. Please type "refresh menu caches" to confirm.',
      'refresh menu caches',
    );
    if (!confirmed) {
      return;
    }

    const $button = $(event.target);
    const reqId = $button.initLoadingButton(
      $button.html(),
      'Making Request',
      'Refresh in Progress',
    );
    const url = '/api/v2/internal-tools/refresh-menu-caches';
    app.makeRequest(
      'POST',
      url,
      null,
      () => {
        $button.loadingDidFinishSuccessfully(reqId);
      },
      () => {
        $button.loadingDidFinishWithError(reqId);
      },
    );
  },

  _syncEsperDevicesClicked(event) {
    const $button = $(event.target);
    const reqId = $button.initLoadingButton($button.html(), 'Syncing...', 'Synced!');
    const url = '/api/v2/internal-tools/sync-esper-devices';
    app.QueueHelper.makeRequest('POST', url, null, true, (err) => {
      if (err) {
        $button.loadingDidFinishWithError(reqId);
      } else {
        $button.loadingDidFinishSuccessfully(reqId);
      }
    });
  },

  _updateSimphonyPasswordsClicked(event) {
    const $button = $(event.target);
    const detailsView = new app.SchemaDetailsView({
      title: 'Update Simphony Passwords',
      saveButtonTitles: ['Update Passwords', 'Updating...', 'Done!'],
      subProperty: 'options',
      schema: {
        fields: updateSimphonyPasswordsSchema.fields.options.fields,
      },
      callback(model) {
        const confirmed = app.promptUserToTypeInConfirmation(
          'Please type in "Update Passwords" to confirm that you want to update all Simphony passwords that match the given criteria.',
          'update passwords',
        );
        if (!confirmed) {
          return;
        }

        const reqId = $button.initLoadingButton($button.html(), 'Updating...', 'Done!');
        const url = '/api/v2/internal-tools/update-simphony-passwords';
        app.QueueHelper.makeRequest('POST', url, model.options, true, (err, jobResult) => {
          if (err) {
            $button.loadingDidFinishWithError(reqId);
          } else {
            $button.loadingDidFinishSuccessfully(reqId);
            new app.AlertView().show(`Update Simphony Passwords Results\n\n${jobResult.result}`);
          }
        });
      },
    });
    app.modalManager.showModalWithView(detailsView);
  },

  _intentionallyCrashClicked() {
    throw new Error('Intentional crash');
  },

  _importUsersFromCsvClicked() {
    app.modalManager.showModalWithView(new app.UserImportModal());
  },

  render() {
    app.BaseToolsView.prototype.render.apply(this, arguments);

    if (app.sessionUser.isBiteOps()) {
      this.addToolbarButton(
        'btn-primary',
        'Refresh Day Parts ⚒',
        this._refreshDayPartsClicked.bind(this),
      );

      this.addToolbarButton(
        'btn-primary',
        'Sync Esper Devices ⚒',
        this._syncEsperDevicesClicked.bind(this),
      );

      this.addToolbarButton(
        'btn-primary',
        'Import Users from CSV ⚒',
        this._importUsersFromCsvClicked.bind(this),
      );
    }

    // Signing in to Simphony is prod-only, so the tool cannot work anywhere else.
    if (app.sessionUser.isBiteSupport() && EnvironmentHelper.isCurrentProd()) {
      this.addToolbarButton(
        'btn-primary',
        'Update Simphony Passwords ⚒',
        this._updateSimphonyPasswordsClicked.bind(this),
      );
    }

    if (app.sessionUser.isBiteEng()) {
      this.addToolbarButton(
        'btn-primary',
        'Intentionally Crash ⚙',
        this._intentionallyCrashClicked.bind(this),
      );

      this.addToolbarButton(
        'btn-danger',
        'Refresh Menu Caches ⚙',
        this._refreshMenuCachesClicked.bind(this),
      );
    }

    return this;
  },
});
